$ = require 'jquery'
ApiError = require 'app/scripts/network/api-error'
Confirm = require 'app/scripts/views/lib/confirm'
Label = require 'app/scripts/models/label'
ModelCache = require 'app/scripts/db/model-cache'
ModelLoader = require 'app/scripts/db/model-loader'
Promise = require 'bluebird'
React = require 'react'
ReactDOM = require 'react-dom'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
l = require 'app/scripts/lib/localize'
localizeServerError = require 'app/scripts/lib/localize-server-error'
parseTrelloUrl = require 'app/scripts/lib/util/url/parse-trello-url'
recup = require 'recup'
{ track } = require '@trello/analytics'
startDecayingInterval = require 'app/scripts/lib/util/decaying-interval'

{
  TrelloCardAttachmentComponent
  TrelloCardAttachmentGenericError
  TrelloCardAttachmentLoading
  TrelloCardAttachmentSpecificError
  TrelloCardAttachmentUnauthorized
} = require './trello-card-attachment-components'

ReactRootComponent = require 'app/scripts/views/internal/react-root-component'

module.exports = class TrelloCardAttachment extends View
  className: 'trello-card-attachment-container'

  initialize: ->
    @$reactRoot ?= $('<div></div>')

    @getCard().then (card) =>
      @card = card
      if @card then @setUpListeners()
      @renderReactSection()
    .catch (e) => console.error e

  setUpListeners: ->
    if @card.getBoard().id != @model.getCard().getBoard().id
      @startPolling()
      return

    renderReactSectionDebounced = @frameDebounce @renderReactSection

    @listenTo @card,
      'change': renderReactSectionDebounced
      'destroy': =>
        @card = null
        @error = 'not found'
        @renderReactSection()

    @listenTo @card.getList(),
      'change:name': renderReactSectionDebounced

    @listenTo @card.getBoard(),
      'change:name': renderReactSectionDebounced
      'change:prefs': (board) ->
        if board.get('prefs')?.backgroundImage != board.previous('prefs')?.backgroundImage or
           board.get('prefs')?.backgroundColor != board.previous('prefs')?.backgroundColor
          @renderReactSection()

  startPolling: ->
    renderCard = =>
      @fetchCard().then =>
        @renderReactSection()

    # Limit server requests using decaying interval
    @cancelDecayingInterval = startDecayingInterval(renderCard)

  getReactRoot: ->
    React.createElement ReactRootComponent, {}, @getTrelloCardAttachment()

  renderReactSection: ->
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])

    @

  render: ->
    @$el.append(@$reactRoot)
    @renderReactSection()

    @

  getTrelloCardAttachmentError: ->
    canEdit = @model.getCard().editable()

    props = {
      @error
      canEdit
      onRemove: @confirmDelete.bind(@)
    }

    recup.render => recup.div =>
      if @error == 'unauthorized'
        recup.createElement TrelloCardAttachmentUnauthorized, props
      else if @error in ['server', 'bad request', 'not found']
        recup.createElement TrelloCardAttachmentSpecificError, props
      else
        recup.createElement TrelloCardAttachmentGenericError, _.extend {
          errorText: localizeServerError(@error)
        }, props

  getTrelloCardAttachment: ->
    if @error
      return @getTrelloCardAttachmentError()

    recup.render => recup.div =>
      if not @card
        return recup.createElement TrelloCardAttachmentLoading

      canRemove = @model.getCard().editable()
      canUnarchive = @card.editable()
      canLink = @card.canAttach()

      modelShortLink = @model.getCard().get('shortLink')
      isLinked = _.some(@card.get('attachments'), (attachment) =>
        parseTrelloUrl(attachment.url).shortLink == modelShortLink
      )

      # This handles the case where the card is linked and then unlinked
      # in the middle of polling (otherwise, "Link" stays hidden indefinitely)
      @$('.link-trello-card').toggle(!isLinked)

      numNotifications = ModelCache.find('Notification', (notification) =>
        notification.get('unread') &&
        notification.get('data')?.card?.id == @card.id
      ).length

      recup.createElement TrelloCardAttachmentComponent, {
        @card
        board: @card.getBoard()
        canLink
        canRemove
        canUnarchive
        isLinked
        labels: @card.getLabels().sort(Label.compare)
        list: @card.getList()
        members: @card.memberList.models
        numNotifications
        onLink: @confirmLink.bind(@, @card)
        onRemove: @confirmDelete.bind(@)
        onUnarchive: @unarchiveCard.bind(@, @card)
      }

  getShortLink: ->
    if not @shortLink
      @shortLink = parseTrelloUrl(@options.cardUrl).shortLink

    @shortLink

  getCard: ->
    shortLink = @getShortLink()

    card = ModelCache.get('Card', shortLink)

    if @isCardDataAvailable(card)
      return Promise.resolve(card)

    @fetchCard()

  isCardDataAvailable: (card) ->
    card and
    card.getBoard() and
    card.getList() and
    card.getLabels() and
    card.get('attachments')

  fetchCard: ->
    shortLink = @getShortLink()

    ModelLoader.loadCardAttachment shortLink
      .then (e) =>
        @error = null
        ModelCache.get('Card', shortLink)
      .catch ApiError.Unauthorized, (e) =>
        @error = 'unauthorized'
        null
      .catch ApiError.NotFound, (e) =>
        @error = 'not found'
        null
      .catch ApiError.Server, (e) =>
        @error = 'server'
        null
      .catch ApiError.BadRequest, (e) =>
        @error = 'bad request'
        null
      .catch (e) =>
        @error = e.message
        null

  confirmDelete: (e) ->
    Util.stop(e)

    Confirm.toggle 'remove attachment',
      elem: @$(e.currentTarget)
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.destroy()
        track("Attachment", "Delete Attachment", @model.getType())

    track("Attachment", "Attachment Thumbnail", "Confirm Delete")

  unarchiveCard: (card, e) ->
    card.update { closed: false }, =>
      track('Card', "Reopen", "Via Trello Attachment")

  confirmLink: (card, e) ->
    Util.stop(e)

    Confirm.toggle 'link attached card',
      elem: @$(e.currentTarget)
      confirmBtnClass: 'primary'
      html: "<img src=\"" + require('resources/images/relate-both-cards.png') + "\" /><br/>" +
        l('confirm.link attached card.text', {
          currentCard: @model.getCard().get('name')
          attachedCard: card.get('name')
        })
      fxConfirm: (e) =>
        @$('.link-trello-card').hide()
        url = @model.getCard().get('shortUrl') || @model.getCard().get('url')
        card.uploadUrl(url)
        track('Card', "Link cards", "Via Trello Attachment")

  remove: ->
    @cancelDecayingInterval?()
    ReactDOM.unmountComponentAtNode(@$reactRoot[0])
    super

